import React from 'react'
import { Tooltip } from 'antd'
import { Icon } from 'antd';
import "./LabelTooltip.scss"
const LabelTooltip = ({label, tooltip, classname="form-label-tooltip"}) => {

  return (
    <div className='ant-form-item-label label'>
      <label>{label}</label>
      <Tooltip className={classname} title={tooltip}>
          <Icon type="info-circle" />
      </Tooltip>
    </div>
  )
}

export default LabelTooltip